import React from 'react'

/**
 * When true, viewport-triggered entrances are held at their initial state instead of playing.
 *
 * This differs from FlipViewportAnimationSuppressContext: that one *skips* the entrance for the
 * duration of a flipbook transition, this one *defers* it. The widget parks at its `from` state
 * and plays the full animation once the hold is released.
 *
 * Used by the IC v2 carousel: the loading overlay is painted on top of a page that is already
 * mounted and laid out, and an IntersectionObserver cannot see that occlusion — so without this,
 * first-screen widgets burn their entrance while they are still covered.
 */
export const ViewportAnimationHoldContext = React.createContext(false)
